/**
 * Date utility functions for handling IST timezone consistently
 */

/**
 * Format a date value to YYYY-MM-DD string in local timezone (IST)
 * Handles Date objects, ISO strings, and already-formatted strings
 * @param {Date|string|null} dateValue - The date to format
 * @returns {string} - Date string in YYYY-MM-DD format, or empty string if null
 */
export const formatDateForInput = (dateValue) => {
  if (!dateValue) return '';
  
  // If it's already a string in YYYY-MM-DD format, return it
  if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue;
  }
  
  // If it's an ISO string or Date object, extract the date part
  if (typeof dateValue === 'string' && dateValue.includes('T')) {
    // ISO string - extract date part before 'T'
    return dateValue.split('T')[0];
  }
  
  // If it's a Date object
  if (dateValue instanceof Date) {
    const year = dateValue.getFullYear();
    const month = String(dateValue.getMonth() + 1).padStart(2, '0');
    const day = String(dateValue.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  return '';
};

/**
 * Format a date to display format (DD/MM/YYYY)
 * @param {Date|string|null} dateValue - The date to format
 * @returns {string} - Date string in DD/MM/YYYY format
 */
export const formatDateForDisplay = (dateValue) => {
  if (!dateValue) return '';
  
  const dateStr = formatDateForInput(dateValue);
  if (!dateStr) return '';
  
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
};

/**
 * Get today's date in YYYY-MM-DD format (IST)
 * @returns {string} - Today's date in YYYY-MM-DD format
 */
export const getTodayIST = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
